import { render, staticRenderFns } from "./EctsPoints.vue?vue&type=template&id=1180a429&"
import script from "./EctsPoints.vue?vue&type=script&lang=js&"
export * from "./EctsPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports